// extracted by mini-css-extract-plugin
module.exports = {"row":"InvoiceRow_row__1Flxo","rowCell":"InvoiceRow_rowCell__2Z79y","header":"InvoiceRow_header__18LtU","footer":"InvoiceRow_footer__3Rcik","padding":"InvoiceRow_padding__1SDFA"};